// @generated by protoc-gen-connect-es v1.1.3 with parameter "target=ts"
// @generated from file gdx/gateway/web/connection/v1/connection_api.proto (package gdx.gateway.web.connection.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { GetEngagementProfilesRequest, GetEngagementProfilesResponse, GetNotificationProfileRequest, GetNotificationProfileResponse, GetOffboardingProfilesRequest, GetOffboardingProfilesResponse, LikeEngagementProfilesRequest, LikeEngagementProfilesResponse } from "./connection_api_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * Contains methods related to users relations, social activity, etc.
 *
 * @generated from service gdx.gateway.web.connection.v1.ConnectionAPI
 */
export const ConnectionAPI = {
  typeName: "gdx.gateway.web.connection.v1.ConnectionAPI",
  methods: {
    /**
     * Like/skip users list from an engagement page ( skipped users data is needed for further analytics ).
     *
     * @generated from rpc gdx.gateway.web.connection.v1.ConnectionAPI.LikeEngagementProfiles
     */
    likeEngagementProfiles: {
      name: "LikeEngagementProfiles",
      I: LikeEngagementProfilesRequest,
      O: LikeEngagementProfilesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns user profiles for last engagement page on onboarding funnel.
     *
     * @generated from rpc gdx.gateway.web.connection.v1.ConnectionAPI.GetEngagementProfiles
     */
    getEngagementProfiles: {
      name: "GetEngagementProfiles",
      I: GetEngagementProfilesRequest,
      O: GetEngagementProfilesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns user profiles for offboarding page funnel.
     *
     * @generated from rpc gdx.gateway.web.connection.v1.ConnectionAPI.GetOffboardingProfiles
     */
    getOffboardingProfiles: {
      name: "GetOffboardingProfiles",
      I: GetOffboardingProfilesRequest,
      O: GetOffboardingProfilesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Returns users profile that matches selected category criteria.
     *
     * @generated from rpc gdx.gateway.web.connection.v1.ConnectionAPI.GetNotificationProfile
     */
    getNotificationProfile: {
      name: "GetNotificationProfile",
      I: GetNotificationProfileRequest,
      O: GetNotificationProfileResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

